export default __webpack_public_path__ + "static/media/menu_whole.266c3cb4.PNG";